import { TextArea } from '@/components/inputs/TextArea'
import styles from './ExpressionFilter.module.css'

export interface ExpressionFilterProps {
  value: string
  onChange: (value: string) => unknown
  onBlur: () => unknown
  isDisabled?: boolean
  testId?: string
}

/**
 * A Ryno formula that resolves to a yes/no.
 */
export function ExpressionFilter({
  value,
  onChange,
  onBlur,
  isDisabled,
  testId,
}: ExpressionFilterProps) {
  return (
    <TextArea
      className={styles.root}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      minRows={2}
      autoSize
      isDisabled={isDisabled}
      placeholder="Enter a Ryno formula here."
      aria-label="Formula"
      data-test={testId}
    />
  )
}
